var map = {
	"./0-5.svg": 883,
	"./10-15.svg": 7003,
	"./15-20.svg": 4320,
	"./20-25.svg": 7273,
	"./25-30.svg": 8532,
	"./30-35.svg": 5379,
	"./35-40.svg": 8604,
	"./40-45.svg": 5301,
	"./45-50.svg": 6744,
	"./5-10.svg": 5026,
	"./50-55.svg": 4867,
	"./55-60.svg": 0,
	"./60-65.svg": 8361,
	"./65-70.svg": 9180,
	"./70-75.svg": 6747,
	"./75-80.svg": 1684,
	"./80-85.svg": 2797,
	"./85-90.svg": 6424,
	"./90-95.svg": 8411,
	"./95-100.svg": 51,
	"./cara-color-bien.svg": 9729,
	"./cara-color-mal.svg": 451,
	"./cara-color-muy-bien.svg": 3689,
	"./cara-color-muy-mal.svg": 6267,
	"./cara-color-normal.svg": 1594,
	"./none.svg": 5625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2077;